import { LocationStoreView } from '../../location/types';
import { v4 } from 'uuid';

export function getForcedResultFromQuery(
    query: string,
    removeSubpremiseSearch?: boolean
): LocationStoreView {
    return {
        areCoordinatesVerified: false,
        classified: false,
        departmentId: -1,
        dispatchArea: '',
        dispatchAreaLabel: '',
        entityLinks: [],
        id: -1,
        isForcedResult: true,
        multiAgencyClassificationDtos: [],
        resolverSource: 'FORCED_LOCATION',
        source: 'FORCED_LOCATION',
        spatialReferenceId: 1,
        streetAddress: removeSubpremiseSearch ? query.split('#')[0] : query,
        uuid: v4(),
        ...getSubpremisesFromQuery(query),
    };
}

function getSubpremisesFromQuery(query: string): Partial<LocationStoreView> {
    // Something like Apt 2, Building A3
    const subpremises = query.split('#').slice(1);
    return subpremises.reduce((acc, subpremise, index) => {
        const [name, value] = subpremise.split(':');

        // If there is a name and no value, we use name as the value
        if (name && !value) {
            return {
                ...acc,
                [`subPremise${index + 1}Name`]: undefined,
                [`subPremise${index + 1}Value`]: name.trim(),
            };
        }

        return {
            ...acc,
            [`subPremise${index + 1}Name`]: name?.trim(),
            [`subPremise${index + 1}Value`]: value?.trim(),
        };
    }, {});
}

export function getSubpremiseForcedResult(
    query: string,
    bestMatchFromSearch?: LocationStoreView
): LocationStoreView | undefined {
    if (query.includes('#') && bestMatchFromSearch !== undefined) {
        return {
            ...bestMatchFromSearch,
            id: -2,
            source: 'FORCED_SUB_PREMISES',
            resolverSource: 'FORCED_SUB_PREMISES',
            isForcedSubpremiseResult: true,
            ...getSubpremisesFromQuery(query),
        };
    }
}

export function getAllForcedResults(
    query: string,
    subpremiseSupport: boolean,
    bestMatchFromSearch?: LocationStoreView
): LocationStoreView[] {
    const allResults = [getForcedResultFromQuery(query)];

    if (subpremiseSupport) {
        const subpremiseForcedResult = getSubpremiseForcedResult(query, bestMatchFromSearch);
        if (subpremiseForcedResult) {
            allResults.unshift(subpremiseForcedResult);
        }
    }

    return allResults;
}

export function removeSubpremisesQueryFromAddress(view: LocationStoreView): LocationStoreView {
    return { ...view, streetAddress: view.streetAddress?.split('#')?.[0] };
}
